<template lang="jade">
    div.Form__body
      nav.Tiles
        div.Tile(v-for="tile in tiles")
          header.Tile__header
            h3.Tile__title {{ tile.legend }}
          div.Tile__body
            component(is="type_button" ":fdata"="tile.button[0]")
          // div.Tile__footer
</template>
<script>
  import _ from 'lodash'
  export default {
    data () {
      return {
        uid: this.$parent.uid
      }
    },
    props: {
      tiles: {
        type: Array,
        coerce: xs => xs.map(x => {
          return _.set(x, 'button', _.find(x.content, ['class', 'buttonGroup']).content)
        }),
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// tiled.vue?70a2b12f